import React, { createContext, useContext, useEffect, useRef } from 'react';

// WebSocket Context'i oluşturun
const WebSocketContext = createContext(null);

// WebSocket Provider bileşeni
export const WebSocketProvider = ({ children }) => {
  const ws = useRef(null);
  
const webSocketURL = 'wss:///64.23.252.49:5000';

  useEffect(() => {
    ws.current = new WebSocket(webSocketURL);
    
    ws.current.onopen = () => console.log('✅ Websocket bağlantısı kuruldu 📡');
    ws.current.onerror = (error) => console.error('🚨 Websocket bağlantı hatası:', error);
    ws.current.onclose = () => console.log('🛑 Websocket bağlantısı kapandı.');

    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, [webSocketURL]);

  return (
    <WebSocketContext.Provider value={ws.current}>
      {children}
    </WebSocketContext.Provider>
  );
};

// WebSocket Context Hook'u
export const useWebSocket = () => useContext(WebSocketContext);